<template>
	<div class="product">
		<ModalSetStore ref="modalSetStore" @action="setMainStore"></ModalSetStore>

		<template v-if="!loading">
			<template v-if="Object.keys(detailProduct).length > 0">
				<v-col class="pt-5">
					<!-- Product Section -->
					<v-row>
						<template v-if="detailLoaded">
							<!-- Product Image Section -->
							<v-col cols="12" sm="12" md="4">
								<!-- Main Product Image -->
								<v-card outlined class="rounded-lg">
									<span v-if="detailStore.store_free_delivery == 'Ya'" class="freeOngkir"></span>
									<v-col class="my-auto pa-1">
										<div class="images cursor-pointer">
											<template v-if="!loadProduct">
												<template v-if="defaultImage">
													<template v-if="defaultImage && defaultImage.type == 'images'">
														<div class="d-block" v-viewer="{movable: false, toolbar: false, fullscreen: true, title:false}">
															<img :src="defaultImage.img ? defaultImage.img : '/assets/product/default.png'" width="100%" class="rounded-lg" />
														</div>
													</template>

													<template v-if="defaultImage && defaultImage.type == 'videos'">
														<div class="video-thumbs-default" @click="openVideoPlayer()">
															<img :src="defaultImage.img ? defaultImage.img : '/assets/product/default.png'" width="100%" class="rounded-lg" />
														</div>
													</template>
												</template>

												<template v-else>
													<div class="d-block">
														<img :src="'/assets/product/default.png'" width="100%" class="rounded-lg" />
													</div>
												</template>
											</template>
											<template v-else>
												<div class="imageLoader">
													<v-progress-circular indeterminate color="primary"></v-progress-circular>
												</div>
											</template>
										</div>
									</v-col>
								</v-card>
								
								<!-- Additional Product images -->
								<div class="pt-3 product-thumbs" >
									<!-- store product thumbs -->
									<template v-if="store_slug_local !== ''">
										<template v-if="imgDetailProduct && imgDetailProduct.length > 0">
											<carousel :loop="false" :nav="false" :dots="false" :responsive="{0:{items:4},600:{items:4},1000:{items:4}}" :mouseDrag="false" :margin="10">
												<div class="pr-2" v-for="(image, index) in imgDetailProduct" :key="'image'+index">
													<v-card outlined class="rounded-lg" @click="defaultImage = image, loadFromApi = false">
														<v-col class="my-auto pa-1" :class="(image.type == 'videos') ? 'videoThumbs' : ''">
															<v-img width="100%" class="rounded-lg" :src="image.img ? image.img : '/assets/product/default.png'"></v-img>
														</v-col>
													</v-card>
												</div>

												<!--  && detailProduct.store_product_product_image_detail.length > 4 -->
												<template v-if="imgDetailProduct">
													<template slot="prev">
														<v-card elevation="0" class="col-12 pa-0">
															<v-btn x-small color="white" elevation="3" fab class="prev prev-thumbs-product">
																<v-icon color="grey darken-1">mdi-chevron-left</v-icon>
															</v-btn>
														</v-card>
													</template>
													<template slot="next">
														<v-card elevation="0" class="col-12 pa-0">
															<v-btn
															x-small
															color="white"
															elevation="3"
															fab
															class="next next-thumbs-product"
															><v-icon color="grey darken-1">mdi-chevron-right</v-icon></v-btn
															>
														</v-card>
													</template>
												</template>
											</carousel>
										</template>
									</template>
									
									<!-- display product thumbs -->
									<template v-else>
										<template v-if="imgDetailProduct && imgDetailProduct.length > 0">
											<carousel :loop="false" :nav="true" :dots="false" :responsive="{0:{items:4},600:{items:4},1000:{items:4}}" :mouseDrag="false" :margin="10">
												<div class="pr-2" v-for="(image, index) in imgDetailProduct" :key="'image'+index">
													<v-card outlined class="rounded-lg" @click="defaultImage = image, loadFromApi = false">
														<v-col class="my-auto pa-1" :class="(image.type == 'videos') ? 'videoThumbs' : ''">
															<v-img width="100%" class="rounded-lg" :src="image.img ? image.img : '/assets/product/default.png'"></v-img>
														</v-col>
													</v-card>
												</div>

												<!--  && detailProduct.product_image_detail.length > 4 -->
												<template v-if="imgDetailProduct">
													<template slot="prev">
														<v-card elevation="0" class="col-12 pa-0">
															<v-btn x-small color="white" elevation="3" fab class="prev prev-thumbs-product">
																<v-icon color="grey darken-1">mdi-chevron-left</v-icon>
															</v-btn>
														</v-card>
													</template>
													<template slot="next">
														<v-card elevation="0" class="col-12 pa-0">
															<v-btn
															x-small
															color="white"
															elevation="3"
															fab
															class="next next-thumbs-product"
															><v-icon color="grey darken-1">mdi-chevron-right</v-icon></v-btn
															>
														</v-card>
													</template>
												</template>
											</carousel>
										</template>
									</template>
								</div>
							</v-col>

							<!-- Product Info Section -->
							<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-4 pb-0 pb-sm-3">
								<div class="text-body-1 text-sm-h6 font-weight-bold">
									<v-chip
										close-icon="mdi-close-outline"
										color="red"
										small
										style="display: inline-block; color: white; font-weight: bold; margin-bottom: 1rem;"
										v-if="detailProduct.store_product_stock_balance == 0"
									>
										<v-avatar left>
											<v-icon dense small>mdi-alert-circle-outline</v-icon>
										</v-avatar>

										STOK KOSONG
									</v-chip>
									<span class="d-block">{{detailProduct.product_name}}</span>
								</div>

								<template v-if="store_slug != undefined">
									<div class="d-flex flex-column pt-3 pt-sm-3 grey--text text--darken-2">
										<div class="text-body-2 d-flex flex-row">
											<div class="text-body-2 d-flex align-center">
												<v-icon small>mdi-cart-check</v-icon>
												<!-- <span class="pl-1">{{detailProduct.product_sold_count | toNumber}} Terjual</span> -->
												<span class="d-inline pl-1">{{ detailProduct.product_buy }} Terjual</span>
											</div>
											<div class="text-body-2 d-flex align-center pl-4">
												<v-icon small class="mt-n1">mdi-eye</v-icon>
												<!-- <span class="pl-1">{{detailProduct.product_view_count | toNumber}} Dilihat</span> -->
												<span class="d-inline pl-1">{{ detailProduct.product_view }} Dilihat</span>
											</div>
										</div>

										<div class="text-h6 text-sm-h6 pt-3 font-weight-bold d-flex">
											<div>
												<template v-if="detailStore.store_free_delivery == 'Ya'">
													<template v-if="detailProduct.product_is_complement == 'Ya'">Rp {{detailProduct.store_product_product_price | toNumber}}</template>
													<template v-else>Rp {{detailProduct.store_product_product_price_margin | toNumber}}</template>
												</template>
												<template v-else>Rp {{detailProduct.store_product_product_price | toNumber}} </template>
												<!-- <sup v-if="detailProduct.product_price != detailProduct.product_price_origin" class="text-decoration-line-through font-size-10 pink--text">Rp {{detailProduct.product_price_origin | toNumber}}</sup> -->
											</div>
										</div>

										<div class="d-flex flex-column pt-5 grey--text text--darken-2">
											<div class="d-block mb-2">
												<div class="text-body-2 font-weight-bold">Informasi produk</div>
											</div>
											<div class="d-flex flex-row align-center justify-item-start mb-1">
												<div class="text-body-2 pr-5" style="width: 100px;">Berat</div>
												<div class="text-body-2">{{detailProduct.product_weight | toKg}}</div>
											</div>
											<!-- <div class="d-flex flex-row align-center justify-item-start mb-1">
												<div class="text-body-2 pr-5" style="width: 100px;">Stok</div>
												<div class="text-body-2">{{detailProduct.store_product_stock_balance | toNoteStock}}</div>
												<div class="text-body-2">{{ detailProduct.store_product_stock_balance }}</div>
											</div> -->
										</div>

										<div class="d-flex pt-5 grey--text text--darken-2">
											<div class="text-body-2 font-weight-bold my-auto">Jumlah</div>
											<v-card elevation="0" width="155" class="pl-5">
												<div class="d-flex">
													<v-btn text x-small color="primary" height="35" :disabled="quantityProduct < 2" @click="quantityProduct--">
														<v-icon>mdi-minus-circle</v-icon>
													</v-btn>
													<v-currency-field class="input-center" v-model="quantityProduct" dense hide-details="auto"></v-currency-field>
													<v-btn text x-small color="primary" height="35" :disabled="quantityProduct >= detailProduct.store_product_stock_balance" @click="quantityProduct++">
														<v-icon>mdi-plus-circle</v-icon>
													</v-btn>
												</div>
											</v-card>
										</div>

										<v-alert
											dense
											type="info"
											text
											class="mt-2"
											color="#168795"
											v-if="quantityProduct >= detailProduct.store_product_stock_balance"
										>
											<small>Saat ini stok produk hanya tersedia <strong class="error--text px-1">{{ detailProduct.store_product_stock_balance }}</strong> Pcs.</small>
										</v-alert>
										
									</div>
								</template>

								<template v-else>
									<div class="d-flex flex-column pt-3 pt-sm-3 grey--text text--darken-2">
										<div class="text-body-2 d-flex flex-column">
											<!-- <div class="text-body-2 d-flex align-center">
												<v-icon small>mdi-cart-check</v-icon>
												<span class="pl-1">{{detailProduct.product_sold_count | toNumber}} Terjual</span>
												<span class="d-inline pl-1">0 Terjual</span>
											</div>
											<div class="text-body-2 d-flex align-center pl-4">
												<v-icon small class="mt-n1">mdi-eye</v-icon>
												<span class="pl-1">{{detailProduct.product_view_count | toNumber}} Dilihat</span>
												<span class="d-inline pl-1">0 Dilihat</span>
											</div> -->
											<div class="text-body-2 d-flex align-center">
												<span class="d-inline">Berat {{detailProduct.product_weight | toKg }}</span>
											</div>

											<div class="text-body-2 d-flex mt-5 flex-column">
												<h4 class="mb-2 primary--text">Deskripsi Produk</h4>
												<span class="white-space-preline" v-html="detailProduct.product_description" v-if="detailProduct.product_description"></span>
												<span v-else>Produk belum memiliki deskripsi.</span>
											</div>
										</div>

										<div class="d-flex pt-5 grey--text text--darken-2" v-if="store_slug !== undefined">
											<div class="text-body-2 font-weight-bold my-auto">Jumlah</div>
											<v-card elevation="0" width="155" class="pl-5">
												<div class="d-flex">
													<v-btn text x-small color="primary" height="35" :disabled="quantityProduct < 2" @click="quantityProduct--">
														<v-icon>mdi-minus-circle</v-icon>
													</v-btn>
													<v-currency-field class="input-center" v-model="quantityProduct" dense hide-details="auto"></v-currency-field>
													<v-btn text x-small color="primary" height="35" @click="quantityProduct++">
														<v-icon>mdi-plus-circle</v-icon>
													</v-btn>
												</div>
											</v-card>
										</div>
									</div>
								</template>

								<div class="d-none d-md-flex pt-5 mt-5" v-if="detailLoaded">
									<!-- :disabled="detailProductSample.stock.store_stock_quantity <= 0" -->
									<!--  v-if="store_slug !== undefined" -->
									<template v-if="store_slug === undefined || store_slug === ''">
										<v-btn depressed height="60" width="250" color="primary" class="rounded-lg" @click="openModalSetStore()">
											<div class="font-weight-bold">Beli Sekarang</div>
										</v-btn>
									</template>

									<template v-else>
										<v-btn outlined height="60" width="250" color="primary" class="rounded-lg" :disabled="(detailProduct.store_product_stock_balance > 0) ? false : true" :loading="loadAddCart" @click="addToCart({store_id: detailStore.store_id, store_slug: detailStore.store_slug, product_id: detailProduct.store_product_id, product_name: detailProduct.product_name, qty: quantityProduct, is_complement: detailProduct.product_is_complement, trxpass: detailProduct.store_product_is_free_delivery, trxpassmargin: detailProduct.free_delivery_margin})">
											<div class="font-weight-bold">Masukkan Keranjang</div>
										</v-btn>
										<v-btn depressed height="60" width="250" color="primary" class="rounded-lg ml-5" :disabled="(detailProduct.store_product_stock_balance > 0) ? false : true" @click="buyProduct({store_id: detailStore.store_id, store_slug: detailStore.store_slug, product_id: detailProduct.store_product_id, product_name: detailProduct.product_name, qty: quantityProduct, is_complement: detailProduct.product_is_complement, trxpass: detailProduct.store_product_is_free_delivery, trxpassmargin: detailProduct.free_delivery_margin})">
											<div class="font-weight-bold">Beli Sekarang</div>
										</v-btn>
									</template>
								</div>
							</v-col>
						</template>

						<v-col cols="12" md="8" class="pl-5 pt-5 d-none" v-else>
							Sedang Memuat...
						</v-col>
					</v-row>

					<!-- Store Info Section -->
					<div class="pt-5" v-if="Object.keys(detailStore).length > 0">
						<v-card outlined class="hwi-border rounded-lg">
							<v-row class="px-3" v-if="detailLoaded">
								<v-col cols="12" md="5">
									<v-row>
										<v-col cols="3" sm="2" md="3" class="py-0 pr-0 my-auto">
											<v-img width="100%" class="border" :src="detailStore.store_image ? detailStore.store_image : '/assets/seller/default-toko.jpg'"></v-img>
										</v-col>
										<v-col cols="9" sm="10" md="9" class="py-0">
											<router-link :to="{ name: 'store-detail', params: { slug: detailStore.store_slug } }" class="text-deco">
												<div class="text-uppercase primary--text font-weight-bold text-subtitle-2">
													{{detailStore.store_name}}
												</div>
											</router-link>
											<div class="pt-1 text-caption text-body-sm-2">{{ detailStore.store_city_name + ', ' + detailStore.store_province_name }}</div>
											<div class="pt-1 text-caption text-body-sm-2">{{ detailStore.store_phone }}</div>
											<div class="d-flex pt-2" v-if="false">
												<v-btn outlined large color="primary" class="px-2 px-md-3 rounded-lg mr-2" v-if="false">
													<v-icon>mdi-chat-processing-outline</v-icon>
													<div class="pl-sm-2 text-caption text-body-sm-2 text-capitalize font-weight-bold d-none d-md-block">Kirim Pesan</div>
												</v-btn>
												<v-btn outlined large color="grey darken-1" class="rounded-lg" @click="gotoStore(detailStore.store_slug)">
													<v-icon>mdi-storefront-outline</v-icon>
													<div class="pl-sm-2 text-caption text-body-sm-2 text-capitalize font-weight-bold d-none d-md-block">Lihat Toko</div>
												</v-btn>
											</div>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="7" class="my-auto left-border text-body-2 d-none d-md-block">
									<v-row class="px-5 d-flex align-start">
										<v-col cols="5">
											<v-row class="d-flex flex-row justify-space-between">
												<v-col class="py-0">Status Toko</v-col>
												<v-col class="py-0 primary--text font-weight-bold text-right">{{ detailStore.store_is_active }}</v-col>
											</v-row>
											<v-row class="d-flex flex-row justify-space-between pt-2">
												<v-col cols="5" class="py-0">Bergabung</v-col>
												<v-col cols="7" class="py-0 primary--text font-weight-bold text-right">{{detailStore.store_input_datetime | tanggal}}</v-col>
											</v-row>
										</v-col>
										<v-col cols="1"></v-col>
										<v-col cols="6">
											<v-row class="d-flex flex-row justify-space-between">
												<v-col cols="5" class="py-0">Total Transaksi</v-col>
												<v-col cols="7" class="py-0 primary--text font-weight-bold text-right">{{ detailStore.total_transaction }}</v-col>
											</v-row>
											<v-row class="d-flex flex-row justify-space-between pt-2">
												<v-col class="py-0">Total Produk</v-col>
												<v-col class="py-0 primary--text font-weight-bold text-right">{{ detailStore.total_product }}</v-col>
											</v-row>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							
						</v-card>
					</div>

					<!-- description section -->
					<template v-if="store_slug !== undefined">
						<div class="pt-5">
							<v-tabs class="no-slider">
								<v-tab class="text-subtitle-1 text-capitalize font-weight-bold" @click="showTab('desc')">Deskripsi Produk</v-tab>
								<!-- <v-tab class="text-subtitle-1 text-capitalize font-weight-bold" @click="showTab('review')">Ulasan Produk ({{productReview.length | toNumber}})</v-tab>
								<v-tab class="text-subtitle-1 text-capitalize font-weight-bold" @click="showTab('discuss')">Diskusi Produk</v-tab> -->
							</v-tabs>
						</div>
						
						<div class="pt-5 pb-2" v-if="tabShow == 'desc'">
							<div class="pt-2">
								<div v-if="detailLoaded" class="text-body-2">
									<template v-if="store_slug_local !== ''">
										<span class="white-space-preline" v-html="detailProduct.store_product_product_description" v-if="detailProduct.store_product_product_description"></span>
										<span v-else>Produk belum memiliki deskripsi.</span>
									</template>
								</div>
								<div v-else>
									<v-alert class="text-body-2" text color="primary">
										Belum ada deskripsi
									</v-alert>
								</div>
							</div>
						</div>
					</template>
					
					<div class="py-5">
						<v-divider></v-divider>
					</div>

					<!-- product Recommendation section -->
					<template v-if="store_slug != '' && store_slug != undefined">
						<ProductCarousel ref="recomended" type="recommended" :slug="store_slug" :store="detailStore" :product="productRecommend.lists"></ProductCarousel>
					</template>
					<template v-else>
						<ProductCarousel ref="recomended" type="displayrecommended" :slug="store_slug" :store="{}" :product="displayRecommend.lists"></ProductCarousel>
					</template>
				</v-col>

				<div class="mobile-add-cart d-block d-md-none">
					<v-row class="pa-3">
						<!-- v-if="store_slug !== undefined" -->
						<template v-if="store_slug === undefined || store_slug === ''">
							<v-col cols="12" class="pl-0 py-0">
								<v-btn block depressed height="60" color="primary" class="rounded-lg" @click="openModalSetStore()">
									<div class="text-caption font-weight-bold">Beli Sekarang</div>
								</v-btn>
							</v-col>
						</template>

						<template v-else>
							<v-col cols="7" class="py-0">
								<v-btn block outlined height="60" color="primary" class="rounded-lg bg-white" :disabled="(detailProduct.store_product_stock_balance > 0) ? false : true" :loading="loadAddCart" @click="addToCart({store_id: detailStore.store_id, store_slug: detailStore.store_slug, product_id: detailProduct.store_product_id, product_name: detailProduct.product_name, qty: quantityProduct, trxpass: detailProduct.store_product_is_free_delivery, is_complement: detailProduct.product_is_complement, trxpassmargin: detailProduct.free_delivery_margin})">
									<div class="text-caption font-weight-bold">Masukkan Keranjang</div>
								</v-btn>
							</v-col>
							<v-col cols="5" class="pl-0 py-0">
								<v-btn block depressed height="60" color="primary" class="rounded-lg" :disabled="(detailProduct.store_product_stock_balance > 0) ? false : true" @click="buyProduct({store_id: detailStore.store_id, store_slug: detailStore.store_slug, product_id: detailProduct.store_product_id, product_name: detailProduct.product_name, qty: quantityProduct, is_complement: detailProduct.product_is_complement, trxpass: detailProduct.store_product_is_free_delivery, trxpassmargin: detailProduct.free_delivery_margin})">
									<div class="text-caption font-weight-bold">Beli Sekarang</div>
								</v-btn>
							</v-col>
						</template>
					</v-row>
				</div>
			</template>

			<template v-else>
				<v-col class="pt-5">
					<div class="pb-5 text-center">
						<v-row class="justify-center">
							<v-col cols="6" sm="5" md="3" class="pb-1">
								<img width="100%" src="/assets/icons/no-product.png">
							</v-col>
						</v-row>
						<div class="text-body-1 text-sm-h5 font-weight-bold my-auto text-center">Produk tidak ditemukan...</div>
						<div class="text-body-2 text-sm-body-1 text-center pt-2">Kembali ke halaman beranda untuk menemukan produk yang Anda maksud.</div>
						<div class="pt-4">
							<router-link :to="'/' + store_slug + '/'" class="text-deco" v-if="store_slug !== ''">
								<v-btn depressed large color="primary" class="text-capitalize font-weight-bold rounded-lg">Kembali ke Beranda</v-btn>
							</router-link>
							<router-link :to="'/'" class="text-deco" v-else>
								<v-btn depressed large color="primary" class="text-capitalize font-weight-bold rounded-lg">Kembali ke Beranda</v-btn>
							</router-link>
						</div>
					</div>
				</v-col>
			</template>
		</template>

		<template v-else>
			<hwiloader :messages="'Sedang memuat data produk...'"></hwiloader>
		</template>

		<v-snackbar
			v-model="snackbar"
			color="success"
			top
			right
		>
			{{ snackbarText }}
		</v-snackbar>

		<v-dialog
      v-model="dialogPlay"
      fullscreen
      :scrim="false"
      transition="dialog-bottom-transition"
			style="background: #000;"
    >
			<v-card style="height: 100%; background: #000;">
				<v-toolbar
					dark
					color="primary"
				>
					<v-btn
						icon
						dark
						@click="dialogPlay = false"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
					
					<span>{{ detailProduct.product_name }}</span>
					<v-spacer></v-spacer>
				</v-toolbar>
				
				<iframe width="100%" height="80%" :src="`https://www.youtube.com/embed/${defaultVideoId}?&autoplay=1&mute=1`" frameborder="0" allowfullscreen></iframe>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import ProductCarousel from '@/views/store/product/ProductCarousel'
import { mapActions , mapState } from 'vuex'
import ModalSetStore from './ModalSetStore.vue'
// import authHelper from '@/helpers/auth'

export default {
	name: 'Product',
	components: {
		carousel, ProductCarousel, ModalSetStore
	},
	data () {
		return {
			loading: false,
			idProduct: '',
			detailProduct: {},
			imgDetailProduct: [],
			dialog: false,
			dialogPlay: false,
			quantityProduct: 1,
			defaultImage: '',
			tabShow: 'desc',
			loadFromApi: false,
			loadProduct: false,
			store_slug: '',
			store_slug_local: '',
			detailStore: {},
			loadAddCart: false,
			hasFreeOngkir: false,
			totalFreeOngkir: 0,
			snackbar: false,
			snackbarText: '',
			defaultVideoId: ''
		}
	},
	watch: {
	},
	computed: {
		...mapState('product', ['displayRecommend', 'productRecommend', 'alert']),
		// ...mapState('store', ['detailStore']),
		// ...mapState('auth', ['userData']),

		detailLoaded() {
			return Object.keys(this.detailProduct).length > 0
		},
		routerParams() {
			return this.$route.params.id
		},
		imageSelected() {
			let image = "/assets/product/default.png"
			// if (this.detailLoaded) {
				if (this.defaultImage) {
					if (this.loadFromApi) {
						// image = (this.detailProduct.product_image[0]) ? this.detailProduct.product_image[0] : image
						image = (this.imgDetailProduct[0].img) ? this.imgDetailProduct[0].img : image
					} else {
						image = this.defaultImage
					}
				} else {
					image = (this.imgDetailProduct[0].img) ? this.imgDetailProduct[0].img : image
				}
			// } 
			return image
		}
	},
	methods: {
		...mapActions('product', ['getDisplayRecommend', 'getProductRecommend']),
		// ...mapActions('store', ['getStoreDetail']),
		// ...mapActions('cart', ['addItemCart', 'getCart']),

		openVideoPlayer() {
			if (this.defaultVideoId !== '') {
				setTimeout(() => {
					this.dialogPlay = true
				}, 200);
			}
		},

		async getStoreDetail() {
			await this.$http
				.get(`/store/detail-store/${this.store_slug}`, {
					// ...this.apiHeaders
				})
				.then((res) => {
					const data = res.data.data
					this.detailStore = data
					if (Object.keys(data).length > 0) localStorage.setItem('HwiEcomStore', this.store_slug)
				})
				.catch(() => {
					// err = error
					// console.log(error.response.data.message)
					this.store_slug = ''
					this.$router.push(`/product/${this.idProduct}`).catch(() => {});
				})
		},

		async getProductDetails() {
			this.loading = await true
			await this.$http
				.get(`/product/detail-product?product_id=${this.idProduct}`, {
					// ...this.apiHeaders
				})
				.then((res) => {
					const data = res.data.data
					this.detailProduct = data

					// if (this.store_slug !== '') this.defaultImage = this.detailProduct.store_product_product_image
					// else this.defaultImage = this.detailProduct.product_image

					// this.imgDetailProduct = this.detailProduct.product_image_detail
					this.detailProduct.product_image_detail.map((img) => {
						this.imgDetailProduct.push({
							type: 'images',
							img: img,
							url: ''
						})
					})

					if (this.detailProduct.product_video) this.imgDetailProduct.unshift({
						type: 'videos',
						img: this.getVideoCover(this.detailProduct.product_video),
						url: this.detailProduct.product_video
					})

					this.defaultImage = this.imgDetailProduct[0]
					console.log(this.imgDetailProduct[0])

					if(this.defaultImage.type == 'videos') this.getVideoId(this.defaultImage.url)

					setTimeout(() => {
						this.loading = false
					}, 1000);
				})
				.catch(() => {
					// err = error
					// console.log(error.response.data.message)
					this.loading = false
				})
		},

		async getProductDetailStore() {
			this.loading = await true
			await this.$http
				.get(`/store-product/detail-store-product/${this.store_slug}?store_product_id=${this.idProduct}`, {
					// ...this.apiHeaders
				})
				.then((res) => {
					const data = res.data.data
					this.detailProduct = data

					// if (this.store_slug !== '') this.defaultImage = this.detailProduct.store_product_product_image
					// else this.defaultImage = this.detailProduct.product_image

					// this.imgDetailProduct = this.detailProduct.store_product_product_image_detail
					this.detailProduct.store_product_product_image_detail.map((img) => {
						this.imgDetailProduct.push({
							type: 'images',
							img: img,
							url: ''
						})
					})

					if (this.detailProduct.store_product_product_video) this.imgDetailProduct.unshift({
						type: 'videos',
						img: this.getVideoCover(this.detailProduct.store_product_product_video),
						url: this.detailProduct.store_product_product_video
					})

					if (this.store_slug !== '') this.defaultImage = this.imgDetailProduct[0]
					else this.defaultImage = this.imgDetailProduct[0]

					if(this.defaultImage.type == 'videos') this.getVideoId(this.defaultImage.url)

					setTimeout(() => {
						this.loading = false
					}, 1500);
				})
				.catch(() => {
					// err = error
					// console.log(error.response.data.message)
					this.loading = false
				})
		},

		getVideoCover(url) {
			if (url) {
				var id = url.match(/(^|=|\/)([0-9A-Za-z_-]{11})(\/|&|$|\?|#)/)[2]
				return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`
			}
		},

		getVideoId(url) {
			if (url) {
				var id = url.match(/(^|=|\/)([0-9A-Za-z_-]{11})(\/|&|$|\?|#)/)[2]
				this.defaultVideoId = id
			}
		},

		gotoStore(store_slug){
			this.$router.push({ name: 'store-detail', params: { slug: store_slug}})
		},

		showTab(tab) {
			this.tabShow = tab
		},

		async addToCart(item) {
			this.loadAddCart = await true
			if (this.store_slug == '' || this.store_slug == undefined) this.openModalSetStore()
			else {
				let existCart = JSON.parse(localStorage.getItem('hwiecom-cart'))
				let params = {
					store_id : item.store_id,
					store_slug : item.store_slug,
					product_id : item.product_id,
					product_name : item.product_name,
					quantity : item.qty,
					is_complement: item.is_complement,
					trx_pass_value: (item.trxpass == 'Tidak') ? 0 : item.trxpassmargin
				}
				
				if (existCart == undefined) {
					localStorage.setItem('hwiecom-cart', JSON.stringify(new Array(params)))
				} else {
					if (existCart.length == 0) {
						localStorage.setItem('hwiecom-cart', JSON.stringify(new Array(params)))
					} else {
						let checkItemIndex = existCart.findIndex(el => el.product_id == this.idProduct )
						
						// console.log(checkItemIndex)
						let newCart = [] 
						if (checkItemIndex < 0) {
							existCart.push(params)
							newCart = existCart
						} else {
							newCart = existCart
							newCart[checkItemIndex] = params
							this.snackbarText = 'Item produk sudah tersedia didalam keranja belanja'
							this.snackbar = true
						}
	
						localStorage.setItem('hwiecom-cart', JSON.stringify(newCart))

					}
				}
			}

			setTimeout(() => {
				// this.checkIsFreeOngkir()
				this.loadAddCart = false
			}, 600);
		},

		async buyProduct(item) {
			if (this.store_slug == '' || this.store_slug == undefined) this.openModalSetStore()
			else {
				await this.addToCart(item)
				this.$router.push({ name: "cart" })
			}
		},

		checkIsFreeOngkir() {
			let existCart = JSON.parse(localStorage.getItem('hwiecom-cart'))

			if (existCart !== undefined) {
				let checkOnFreeOngkir = existCart.findIndex(el => el.trx_pass_value > 0 )
				if (checkOnFreeOngkir > 0) { 
					this.hasFreeOngkir = true
					this.totalFreeOngkir = existCart.map(item => item.trx_pass_value).reduce((prev, next) => prev + (next.trx_pass_value * next.quantity));
				}
				else {
					this.hasFreeOngkir = false
					this.totalFreeOngkir = 0
				}
			}
		},

		changeProduct(id) {
			this.$router.replace({ name: 'product-detail', params: { id: id}})
		},

		openModalSetStore(){
			this.$refs.modalSetStore.modalShow();
		},
		setMainStore() {},
		
		copyme() {
			var copyText = document.getElementById("inputCopy")
			copyText.setAttribute('type', 'text')
			copyText.select()
			try {
				document.execCommand('copy');
				setTimeout(() => {
					this.$store.commit('makeAlert', { code: 'success', type: 'success', message: 'Tautan berhasil disalin', show: true });
				}, 300);
			} catch (err) {
				alert('Oops, tidak dapat menyalin');
			}
			copyText.setAttribute('type', 'hidden')
			window.getSelection().removeAllRanges()
		},

		genSamples(data, loop) {
			let newdata = []
			for (let i = 0; i < loop; i++) {
				data.map((item) => {
					let prd = item
					newdata.push(prd)
				})
			}
			
			return newdata
		}
	},
	async created() {
		this.loading = await true
		this.idProduct = await this.$route.params.id
		let store_slug = await this.$route.params.slug
		this.store_slug = await (store_slug !== '' || store_slug != undefined) ? store_slug : ''
		this.store_slug_local = await localStorage.getItem('HwiEcomStore')
		
		if (store_slug == undefined || store_slug == '') {
			// this.store_slug = await ''
			// await localStorage.setItem('HwiEcomStore', '')
			await this.getProductDetails()
			// this.defaultImage = this.detailProduct.product_image
			this.getDisplayRecommend()
		} else {
			// this.store_slug = await store_slug
			// await localStorage.setItem('HwiEcomStore', store_slug)
			await this.getStoreDetail()
			// this.defaultImage = this.detailProduct.store_product_product_image
			this.getProductDetailStore()
			this.getProductRecommend()
		}
	},
};
</script>

<style lang="scss">
.imageLoader {
	width: 360px;
	height: 370px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f9f9f9;
	z-index: 99;
}	
.tempImage {
	opacity: 0.2;
	z-index: 1;
}

.video-thumbs-default {
	display: block;
	position: relative;

	&::before {
		background: rgba(0,0,0,0.1);
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: 1;
		content: '';
	}

	&:hover::before {
		background: rgba(0,0,0,0.6);
	}

	&::after {
		background: rgba(255,255,255,0.25);
		position: absolute;
		width: 32%;
		height: 40%;
		z-index: 3;
		content: "\F040D";
		display: flex;
		align-items: center;
		justify-content: center;
		font: normal normal normal 60px "Material Design Icons";
		color: #168796;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		border-radius: 100%;
	}

	&:hover::after {
		color: #B3D234;
	}

}

.videoThumbs { 
	display: block;
	position: relative;

	&::before {
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: 1;
		content: '';
	}

	&:hover::before {
		// background: rgba(0,0,0,0.6);
	}

	&::after {
		background: rgba(255,255,255,0.45);
		position: absolute;
		width: 52%;
		height: 60%;
		z-index: 3;
		content: "\F040D";
		display: flex;
		align-items: center;
		justify-content: center;
		font: normal normal normal 28px "Material Design Icons";
		color: #168796;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		border-radius: 100%;
	}

	&:hover::after {
		background: rgba(255,255,255,0.85);
		// color: #B3D234;
	}
}
</style>